import store from '@/store'

const TokenKey = 'API_JSESSIONID_TASK'

export function getToken () {
  let key = TokenKey
  let token = window.sessionStorage.getItem(key)
  if (token === undefined || token == null) {
    token = getCookieV(key)
  }
  if (token === undefined || token == null) {
    return ''
  }
  return token
}

export function setToken (token) {
  let key = TokenKey
  setCookie(key,token,1)
  return window.sessionStorage.setItem(key, token)
}

export function removeToken () {
  let key = TokenKey
  //window.localStorage.removeItem(key)
  setCookie(key,"",1)
  return window.sessionStorage.removeItem(key)
}
//创建cookie
export function setCookie(c_name,value,expiredays)
{
var exdate=new Date();
exdate.setDate(exdate.getDate()+expiredays);
document.cookie=c_name+ "=" +escape(value)+((expiredays==null) ? "" : ";expires="+exdate.toGMTString());
}

//读取cookie
export function getCookieV(c_name)
{
  var c_start=-1;
  var c_end=-1;
if (document.cookie.length>0)
  {
  c_start=document.cookie.indexOf(c_name + "=")
  if (c_start!=-1)
    { 
    c_start=c_start + c_name.length+1 
    c_end=document.cookie.indexOf(";",c_start)
    if (c_end==-1) c_end=document.cookie.length
    return unescape(document.cookie.substring(c_start,c_end))
    } 
  }
return ""
}